import React, { FC, PropsWithChildren } from 'react';

import { Product } from 'src/api/@generated/backend';

import { DataLayerWrapper } from 'src/components/data-layer-wrapper/data-layer-wrapper';
import { DataLayerEvent } from 'src/types/data-layer-event-object';
import { DataLayerUtils } from 'src/utils/data-layer-utils';

interface Props {
  products: Product[];
}

export const DataLayerViewItemsWrapper: FC<PropsWithChildren<Props>> = (props) => {
  const { products, children } = props;

  return (
    <DataLayerWrapper
      pushToDataLayer={() => DataLayerUtils.pushToProductsDataLayer(DataLayerEvent.VIEW_ITEM_LIST, products)}
    >
      {children}
    </DataLayerWrapper>
  );
};
